// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__8IqwQ","content":"content__3-mXy","heading":"heading__XJWR2"};